import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { motion } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";
import { useVerifyOtpMutation, useRequestOtpMutation } from "../toolkitServices/userApi";
import toast from "react-hot-toast";

const VerifyOtp = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { register, handleSubmit, formState: { errors } } = useForm();

  const [verifyOtp, { isLoading }] = useVerifyOtpMutation();
  const [requestOtp, { isLoading: isResending }] = useRequestOtpMutation();

  const maskedPhone =
    state?.phone?.length === 10
      ? `+91-******${state.phone.slice(-4)}`
      : state?.phone || "";

  const onSubmit = async (data) => {
    try {
      await verifyOtp({ phone: state.phone, otp: data.otp }).unwrap();
      toast.success("OTP verified!");
      navigate("/reset-password", { state });
    } catch (err) {
      toast.error(err?.data?.msg || "Invalid or expired OTP");
    }
  };

  const handleResend = async () => {
    try {
      await requestOtp({ phone: state.phone }).unwrap();
      toast.success("OTP resent successfully!");
    } catch (err) {
      toast.error(err?.data?.msg || "Failed to resend OTP");
    }
  };

  return (
    <div className="flex items-center justify-center h-screen bg-[#f9f4e8]">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="bg-white shadow-lg rounded-xl p-8 w-96"
      >
        <h2 className="text-xl font-semibold text-gray-800 mb-4 text-center">
          Verify OTP
        </h2>

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <p className="text-sm text-gray-600 text-center mb-3">
            OTP sent to <b>{maskedPhone}</b>
          </p>

          <div>
            <input
              {...register("otp", {
                required: "Please enter the OTP",
                minLength: { value: 4, message: "Invalid OTP length" },
              })}
              type="text"
              placeholder="Enter OTP"
              className={`w-full border ${
                errors.otp ? "border-red-400" : "border-gray-300"
              } rounded px-3 py-2 focus:ring-2 focus:ring-[#7d70b2]`}
            />
            {errors.otp && (
              <p className="text-red-500 text-xs mt-1">{errors.otp.message}</p>
            )}
          </div>

          <button
            disabled={isLoading}
            type="submit"
            className="w-full bg-[#7d70b2] hover:bg-[#6e63a5] text-white py-2 rounded-md transition"
          >
            {isLoading ? "Verifying..." : "Verify OTP"}
          </button>

          {/* Resend OTP */}
          <div className="text-center mt-2">
            <button
              type="button"
              onClick={handleResend}
              disabled={isResending}
              className="text-sm text-blue-500 hover:underline disabled:opacity-60"
            >
              {isResending ? "Resending..." : "Resend OTP"}
            </button>
          </div>
        </form>
      </motion.div>
    </div>
  );
};

export default VerifyOtp;
